import MfButton from '@components/branded/MfButton'
import { ChevronLeft } from 'react-feather'
import history from '../../history'

const chevronSizes = {
  sm: 16,
  md: 18,
  lg: 20
}

const BackButton = ({ outline = false, margin = 'left', size = 'sm' }) => {
  return (
    <MfButton
      size={size}
      outline={outline}
      color="danger"
      className={`btn-${margin}-space`}
      onClick={history.back}
      style={{
        position: 'relative', // Required for absolute positioning of icon
        paddingLeft: `${chevronSizes[size] + 8}px` // Add space for icon (icon + 8px gap)
      }}
    >
      <ChevronLeft
        size={chevronSizes[size]}
        style={{
          position: 'absolute',
          left: '8px',
          top: '50%',
          transform: 'translateY(-50%)'
        }}
      />
      Back
    </MfButton>
  )
}

export default BackButton
